import {
  FormControlLabel,
  TextField,
  IconButton,
  Box,
  SvgIcon,
  Typography,
  Stack,
} from "@mui/material";
import { Controller } from "react-hook-form";
import _ from "lodash";
import { Add as AddIcon, Remove as RemoveIcon } from "@mui/icons-material";

const NumberInput = ({
  name,
  form: { control, setValue },
  required,
  min = 1,
  max,
  disabled
}) => {
  const increase = currentValue => setValue(name, currentValue + 1);
  const decrease = currentValue => setValue(name, currentValue - 1);

  return (
    <Controller
      name={name}
      control={control}
      rules={{
        required,
      }}
      render={({ field: { value: currentValue } }) => {
        const increaseDisabled = currentValue == max || disabled;
        const decreaseDisabled = currentValue == min || disabled;

        return (
          <Stack
            direction="row"
            alignItems="center"
            sx={{
              border: "1px solid #BCC1C3",
              backgroundColor: "text.white",
              borderRadius: 1,
              height: "max-content",
            }}
          >
            <IconButton size="small" onClick={() => decrease(currentValue)} disabled={decreaseDisabled}>
              <RemoveIcon sx={{
                fontSize: 15,
                color: !decreaseDisabled && "primary.main",
              }}
            />
            </IconButton>
            <Typography
              sx={{
                fontSize: 14,
                mx: 2,
                borderRadius: 1,
                width: 10,
                textAlign: "center",
                userSelect: "none",
              }}
            >
              {currentValue}
            </Typography>
            <IconButton size="small" onClick={() => increase(currentValue)} disabled={increaseDisabled}>
              <AddIcon sx={{
                fontSize: 15,
                color: !increaseDisabled && "primary.main",
                }}   
              />
            </IconButton>
          </Stack>
        );
      }}
    />  
  );
};

export default NumberInput;
